import { createAction } from "redux-act";

export const REQConsentVSList = createAction("REQUEST_CONSENTVS_LIST");
export const RESConsentVSList = createAction("RECEIVE_CONSENTVS_LIST");
export const FailConsentVSList = createAction("FAILED_CONSENTVS_LIST");
export const CleanUpConsentVSList= createAction("CLEANUP_CONSENTVS_LIST");

// MEM
export const MEMConsentVSList= createAction("MEM_CONSENTVS_LIST");
